import { useContext } from 'react';
import { ProviderContext } from './IocContext';
import { interfaces } from 'inversify';

export function useInjection<T>(identifier: interfaces.ServiceIdentifier<T>) {
  const container = useContext(ProviderContext);
  if (!container) {
    throw new Error();
  }
  return container.get<T>(identifier);
}
